import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import i18n from '@/shared/lib/i18n';
import type { SupportedLanguage } from '@/shared/lib/i18n';

export interface LanguageState {
  language: SupportedLanguage;
  setLanguage: (lang: SupportedLanguage) => void;
}

export const useLanguage = create<LanguageState>()(
  persist(
    (set) => ({
      language: (i18n.language as SupportedLanguage) || 'en',
      setLanguage: (language) => {
        void i18n.changeLanguage(language);
        set({ language });
      },
    }),
    {
      name: 'loki-language',
    },
  ),
);

// ── Cross-tab sync ───────────────────────────────────────────────────────────
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key === 'loki-language' && e.newValue) {
      try {
        const parsed = JSON.parse(e.newValue) as { state?: { language?: string } };
        const lang = parsed?.state?.language;
        if (lang === 'en' || lang === 'pt-BR') {
          useLanguage.setState({ language: lang });
          void i18n.changeLanguage(lang);
        }
      } catch {
        /* noop */
      }
    }
  });
}
